<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Switch Organization</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer">
                <span (click)="onClose()" aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="modal-sub-heading">Login to one of your other organizations</div>
</div>

<div class="modal-body" [formGroup]="form">
    <div class="mx-3 mt-n3">
        <div class="body-2 text-center">Current Organization: <b>{{organization.name}}</b> as the {{accessText}}</div>
    </div>
    <div class="mx-3 mt-5">
        <app-jquery-select-control
            formControlName="organization"
            [list]="organizations"
            label="Select Organization"
        ></app-jquery-select-control>
    </div>
</div>

<div class="modal-footer paybee-modal-footer d-flex justify-content-center">
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="onSwitch()">Login To {{form.get("organization").value.name}}</a>
</div>
